import React, { useEffect, useRef, useState } from "react";
import QRCode from "react-qr-code";
import type { TimelineEvent } from "./timelineConfig";
import ReactCardFlip from "react-card-flip";
import QRIcon from "./timelineAssets/qrcode.svg";
import { EVENT_WIDTH } from "../../utils/consts";

interface TimelineItemProps {
  event: TimelineEvent;
  top: boolean;
  updateVisibility: (isVisible: boolean) => void;
}

const TimelineItem: React.FC<TimelineItemProps> = ({
  event,
  top,
  updateVisibility,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const elementRef = useRef<HTMLDivElement>(null);
  const [isFlipped, setIsFlipped] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        // For each entry, check if it is fully visible
        entries.forEach((entry) => {
          setIsVisible(entry.isIntersecting);
          updateVisibility(entry.isIntersecting);
        });
      },
      {
        root: null, // observing for the whole viewport, not a specific element
        rootMargin: "0px",
        threshold: 0.8, // 1.0 means fully inside the viewport
      }
    );

    if (elementRef.current) {
      observer.observe(elementRef.current);
    }

    const refCopy = elementRef.current;

    return () => {
      if (refCopy) {
        observer.unobserve(refCopy);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const flipCard = () => {
    setIsFlipped(!isFlipped);
    setTimeout(() => {
      setIsFlipped(false);
      console.log("flipped");
    }, 10000);
  };

  return (
    <div
      className="transition eventContainer"
      ref={elementRef}
      style={{
        width: EVENT_WIDTH,
        alignItems: top ? "flex-end" : "flex-start",
        opacity: isVisible ? 1 : 0.5,
      }}
    >
      <div style={{ display: "flex", flexDirection: "column-reverse" }}>
        {top ? (
          <>
            <div className="markerContainterTop">
              <div className="markerLineTop">
                <svg
                  width="6"
                  height="69"
                  viewBox="0 0 6 69"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    id="Vector 8"
                    d="M3 68.479L3 0.791796"
                    stroke="#DADADA"
                    strokeWidth="5"
                    strokeDasharray="8 10"
                    strokeLinecap="round"
                  />
                </svg>
              </div>
              <div className="markerTop"></div>
            </div>
            <ReactCardFlip isFlipped={isFlipped} flipDirection="horizontal">
              <div className="eventImgContainer" key="front">
                <div className="qrIconContainer" onClick={flipCard}>
                  <div className="qrIconCircle">
                    <img className="qrIcon" src={QRIcon}></img>
                  </div>
                </div>
                <img
                  className="eventImg"
                  src={event.img}
                  alt={event.name}
                  onClick={flipCard}
                />
              </div>
              <div className="eventImgContainer" key="back">
                <div className="eventImg">
                  <QRCode
                    value={event.qr}
                    className="qrCode"
                    bgColor="#00000000"
                    onClick={flipCard}
                  />
                </div>
              </div>
            </ReactCardFlip>
          </>
        ) : (
          <>
            <ReactCardFlip isFlipped={isFlipped} flipDirection="horizontal">
              <div className="eventImgContainer" key="front">
                <div className="qrIconContainer" onClick={flipCard}>
                  <div className="qrIconCircle">
                    <img className="qrIcon" src={QRIcon}></img>
                  </div>
                </div>
                <img
                  className="eventImg"
                  src={event.img}
                  alt={event.name}
                  onClick={flipCard}
                />
              </div>
              <div className="eventImgContainer" key="back">
                <div className="eventImg">
                  <QRCode
                    value={event.qr}
                    className="qrCode"
                    bgColor="#00000000"
                    onClick={flipCard}
                  />
                </div>
              </div>
            </ReactCardFlip>
            <div className="markerContainterBottom">
              <div className="markerBottom"></div>
              <div className="markerLineBottom">
                <svg
                  width="6"
                  height="69"
                  viewBox="0 0 6 69"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    id="Vector 8"
                    d="M3 68.479L3 0.791796"
                    stroke="#DADADA"
                    strokeWidth="5"
                    strokeDasharray="8 10"
                    strokeLinecap="round"
                  />
                </svg>
              </div>
            </div>
          </>
        )}
      </div>
      <div className="eventTextContainer">
        <div className="yearText">{event.year}</div>
        <div className="nameText">{event.name}</div>
        <div className="descriptionText">{event.description}</div>
      </div>
    </div>
  );
};

export default TimelineItem;
